import * as React from 'react';
import { Navigate, useLocation } from "react-router";
import { useAuth } from "../hooks/useAuth";

interface Props {
    children: JSX.Element | JSX.Element[];
}

const ProtectedRoute = ({ children }: Props): JSX.Element | null => {
    const auth = useAuth();
    const location = useLocation();
    const [isActive, setIsActive] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        const fetch = async () => {
            setIsActive(auth && (await auth.isActive()));
        };
        // todo: setTimeout 
        // JSON.parse(atob(token.split('.')[1])).exp*1000 - new Date().getTime()

        // 250 sec assuming 5 min token lifetime
        const interval = setInterval(fetch, 250_000); 
        fetch().catch(console.error);
        return () => {
            clearInterval(interval);
        }
    }, [auth]);


    return (isActive)
        ? <>{children}</>
        : (isActive === false
            ? <Navigate to="/login" replace state={{ from: location }} />
            : null
        )
};

export default ProtectedRoute;